import { cloneDeep, times } from 'lodash';
import createTaskType from '../../createTaskType';
import PostersAndMessagesEditor from './Editor';

export default createTaskType({
  id: 'posters_and_messages',
  label: 'Posters and Messages',
  skill: 'reading_writing',
  v2: true,
  hasRubric: true,
  editor: PostersAndMessagesEditor,
  createItemsTemplate: (() => [
    createPostersTaskItem({ isExample: true }), ...times(5, createPostersTaskItem)
  ]),
  convertToUploadFormat(task, { isNew }) {
    task = cloneDeep(task);
    task.items = task.items.map(item => {
      if (item.template_type === 'poster') {
        delete item.note_text;
        delete item.note_image;
        delete item.phone_text;
        delete item.phone_image;
        delete item.email_image;
        delete item.email_header_line;
        delete item.email_to_id;
        delete item.email_from_id;
        delete item.email_message;
      } else if (item.template_type === 'note'|| item.is_example) {
        delete item.poster_title;
        delete item.poster_main_text;
        delete item.poster_image;
        delete item.poster_picture_image;
        delete item.phone_text;
        delete item.phone_image;
        delete item.email_image;
        delete item.email_header_line;
        delete item.email_to_id;
        delete item.email_from_id;
        delete item.email_message;
      } else if (item.template_type === 'phone') {
        delete item.poster_title;
        delete item.poster_main_text;
        delete item.poster_image;
        delete item.poster_picture_image;
        delete item.note_text;
        delete item.note_image;
        delete item.email_image;
        delete item.email_header_line;
        delete item.email_to_id;
        delete item.email_from_id;
        delete item.email_message;
      } else if (item.template_type === 'email') {
        delete item.poster_title;
        delete item.poster_main_text;
        delete item.poster_image;
        delete item.poster_picture_image;
        delete item.note_text;
        delete item.note_image;
        delete item.phone_text;
        delete item.phone_image;
      }
      else {
        delete item.poster_title;
        delete item.poster_main_text;
        delete item.poster_image;
        delete item.poster_picture_image;
        delete item.note_text;
        delete item.note_image;
        delete item.phone_text;
        delete item.phone_image;
        delete item.email_image;
        delete item.email_header_line;
        delete item.email_to_id;
        delete item.email_from_id;
        delete item.email_message;
      }

      return item;
    });

    return task;
  },

  getKeys: (item) => {
    return item.answers
      .filter(x => x.is_correct_answer)
      .map(x => `Option ${'ABC'[x.order - 1]} - ${x?.key_text ?? x.image_id}`);
  }
});


export function createPostersTaskItem({ isExample = false } = {}) {
  return {
    is_example: isExample,
    ...(isExample && { rubric_id: '' }),
    template_type: '',
    stimulus_text: '',
    background_image: '',
    poster_title: '',
    poster_main_text: '',
    poster_image: '',
    poster_picture_image: '',
    note_text: '',
    note_image: '',
    phone_text: '',
    phone_image: '',
    email_image: '',
    email_header_line: '',
    email_to_id: '',
    email_from_id: '',
    email_message: '',
    answers: times(3, () => ({
      is_correct_answer: false,
      key_text: ''
    }))
  };
}